import * as React from 'react'
import { ChangeHandler } from 'react-hook-form'
import { CheckboxButton } from './checkbox-button'

type CheckboxButtonProps = React.ComponentProps<typeof CheckboxButton>

export type CheckboxVariant = 'default' | 'outlined'

export type CheckboxProps = CheckboxButtonProps & {
  label?: string
  name?: string
  onChange?: ChangeHandler
  error?: string
  variant?: CheckboxVariant
}
